import { m } from '@pricedrop/i18n';
import { createFileRoute } from '@tanstack/react-router';
import BookOpen from 'lucide-react/dist/esm/icons/book-open';
import Keyboard from 'lucide-react/dist/esm/icons/keyboard';
import Mail from 'lucide-react/dist/esm/icons/mail';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { buildMeta } from '@/lib/seo';

export const Route = createFileRoute('/_authed/help/')({
  head: () => ({
    meta: buildMeta({
      title: 'עזרה - Pricedrop',
      description: '',
      canonicalUrl: '/help',
      noindex: true,
    }),
  }),
  component: HelpPage,
});

function HelpPage() {
  return (
    <div className="container mx-auto px-4">
      <div className="space-y-4 py-6">
        <div className="flex items-center justify-between">
          <h2 className="text-3xl font-bold tracking-tight">{m.help_title()}</h2>
        </div>

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          <Card>
            <CardHeader>
              <div className="flex items-center gap-2">
                <BookOpen className="h-5 w-5 text-muted-foreground" />
                <CardTitle>{m.help_gettingStarted_title()}</CardTitle>
              </div>
              <CardDescription>{m.help_gettingStarted_description()}</CardDescription>
            </CardHeader>
            <CardContent>
              <ol className="list-decimal space-y-2 ps-5 text-sm text-muted-foreground">
                <li>{m.help_gettingStarted_item1()}</li>
                <li>{m.help_gettingStarted_item2()}</li>
                <li>{m.help_gettingStarted_item3()}</li>
                <li>{m.help_gettingStarted_item4()}</li>
              </ol>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <div className="flex items-center gap-2">
                <Keyboard className="h-5 w-5 text-muted-foreground" />
                <CardTitle>{m.help_shortcuts_title()}</CardTitle>
              </div>
              <CardDescription>{m.help_shortcuts_description()}</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-3 text-sm">
                <div className="flex items-center justify-between">
                  <span className="text-muted-foreground">{m.help_shortcuts_commandMenu()}</span>
                  <kbd className="rounded border bg-muted px-2 py-0.5 font-mono text-xs">
                    Ctrl+K
                  </kbd>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-muted-foreground">{m.help_shortcuts_search()}</span>
                  <kbd className="rounded border bg-muted px-2 py-0.5 font-mono text-xs">/</kbd>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <div className="flex items-center gap-2">
                <Mail className="h-5 w-5 text-muted-foreground" />
                <CardTitle>{m.help_contact_title()}</CardTitle>
              </div>
              <CardDescription>{m.help_contact_description()}</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                {m.help_contact_email()}{' '}
                <a
                  href={`mailto:${m.help_contact_emailAddress()}`}
                  className="font-medium text-primary underline underline-offset-4"
                >
                  {m.help_contact_emailAddress()}
                </a>
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
